// categoriesData.js
export const categories = [
  { name: "commercials", id: "1" },
  { name: "long-format", id: "2" },
  { name: "short-documentaries", id: "3" },
];

// subCategoriesData.js
export const subCategories = [
  { name: "latest-release", id: "101", categoryId: "1" },
  { name: "all", id: "102", categoryId: "1" },
  { name: "upcoming", id: "103", categoryId: "1" },
  { name: "latest-release", id: "201", categoryId: "2" },
  { name: "all", id: "202", categoryId: "2" },
  { name: "upcoming", id: "203", categoryId: "2" },
  { name: "latest-release", id: "301", categoryId: "3" },
  { name: "all", id: "302", categoryId: "3" },
  { name: "upcoming", id: "303", categoryId: "3" },
];

export const commercials = [
  {
    id: 1,
    name: "Snicker's Veerappan",
    videoId: 278664507,
    url: "https://vimeo.com/278664507",
    thumbnail: "/category/commercials/1.png",
    // hyundai
    src: "category/commercials/10.jpeg",
    title: "images/753845722_karmma_calling.png",
    content: "Snicker's Veerappan",
    year: "2024",
    season: "1 Season",
    // language: "7 Languages",
    rating: "U/A 16+",
    description:
      "Jake Sully and Neytiri fight to protect their family from new threats.",
    genres: ["Thriller", "Adventure"],
  },
  {
    id: 2,
    videoId: 693482697,
    url: "https://vimeo.com/693482697",
    // vadilal
    thumbnail: "/category/commercials/2.avif",
    src: "/category/commercials/2.avif",
    title: "images/753845722_karmma_calling.png",
    content: "Maruti Suzuki Vitara Brezza",
    year: "2024",
    season: "1 Season",
    // language: "7 Languages",
    rating: "U/A 16+",
    description:
      "Explore the origins of the Witcher universe in this epic tale of magic and monsters.",
    genres: ["Drama", "Action"],
  },
  {
    id: 3,
    videoId: 520815980,
    url: "https://vimeo.com/520815980",
    thumbnail: "/category/commercials/3.avif",
    src: "/category/commercials/3.avif",
    title: "images/753845722_karmma_calling.png",
    content: "The Divide - Social experiment",
    year: "2024",
    season: "1 Season",
    // language: "7 Languages",
    rating: "U/A 12+",
    description:
      "Peter Parker's journey continues as he takes on new villains and navigates the challenges.",
    genres: ["Action", "Adventure"],
  },
  {
    id: 4,
    videoId: 878234531,
    url: "https://vimeo.com/878234531",
    thumbnail: "/category/commercials/4.avif",
    // hunk
    src: "/category/commercials/4.avif",
    title: "images/753845722_karmma_calling.png",
    content: "Grants",
    year: "2024",
    season: "1 Season",
    // language: "7 Languages",
    rating: "U/A 16+",
    description:
      "Nothing matters when the world is at your feet. But can anyone really cheat one's Karma?",
    genres: ["Drama", "Thriller"],
  },
  {
    id: 5,
    videoId: 878238516,
    url: "https://vimeo.com/878238516",
    // godrej
    thumbnail: "/category/commercials/5.avif",
    src: "/category/commercials/5.avif",
    title: "images/753845722_karmma_calling.png",
    content: "Havells Appliances",
    year: "2024",
    season: "1 Season",
    // language: "7 Languages",
    rating: "U/A 16+",
    description:
      "Nothing matters when the world is at your feet. But can anyone really cheat one's Karma?",
    genres: ["Thriller", "Adventure"],
  },

  // Add more objects as needed
];

export const longformat = [
  {
    id: 1,
    name: "Guilty (2020)",
    videoId: 693910565,
    url: "https://vimeo.com/693910565",
    thumbnail: "/category/longformat/2.jpeg",
    src: "/category/longformat/2.jpeg",
    title: "/images/753845722_karmma_calling.png",
    content: "Guilty",
    year: "2020",
    season: "",
    language: "7 Languages",
    rating: "U/A 16+",
    description:
      "When a popular college heartthrob (Gurfateh Pirzada) is accused of rape by an introverted student, his girlfriend (Kiara Advani) embarks on a journey to uncover the truth, sifting through conflicting accounts and confronting her own beliefs in the process.",
    genres: ["Thriller", "Adventure"],
    starring: ["Kiara Advani", "Taher Shabbir", "Gurfateh Pirzada", "Akanksha Ranjan Kapoor"],
    director: "Ruchi Narain",
  },
  {
    id: 2,
    name: "Hanuman Da Damdaar",
    videoId: 275610776,
    url: "https://vimeo.com/275610776",
    thumbnail: "/category/longformat/1.jpeg",
    src: "/category/longformat/1.jpeg",
    title: "/images/753845722_karmma_calling.png",
    content: "Hanuman Da Damdaar",
    year: "2017",
    season: "",
    language: "7 Languages",
    rating: "U/A 16+",
    description:
      "Witness young Maruti transform from a meek child into the mighty Hanuman Da' Damdaar, learning courage and self-belief along the way. With its unique blend of vibrant animation, heartfelt storytelling, and laugh-out-loud humour, Hanuman Da’ Damdaar takes audiences on an unforgettable adventure filled with action, emotion, and the timeless journey of re-discovering a much-loved character.",
    genres: ["Drama", "Action"],
    starring: ["Salman Khan", "Saurabh Shukla", "Raveena Tandon", "Vinay Pathak", "Kunal Khemu", "Javed Akhtar"],
    director: "Ruchi Narain",
  },
  {
    id: 3,
    name: "Hanuman Chalisa",
    videoId: 275610776,
    url: "https://vimeo.com/275610776",
    thumbnail: "/category/longformat/1.jpeg",
    src: "/category/longformat/1.jpeg",
    title: "/images/753845722_karmma_calling.png",
    content: "Hanuman Chalisa",
    year: "2017",
    season: "",
    language: "7 Languages",
    rating: "U/A 12+",
    description:
      "A devotional hymn dedicated to Lord Hanuman, recited for strength, courage, and divine blessings.",
    genres: ["Religious", "Devotional"],
    starring: ["Amitabh Bachchan (Narration)"],
    director: "",
  },
  {
    id: 4,
    name: "The Hundred",
    videoId: 521252910,
    url: "https://vimeo.com/521252910",
    thumbnail: "/category/longformat/3.jpeg",
    src: "/category/longformat/3.jpeg",
    title: "/images/753845722_karmma_calling.png",
    content: "The Hundred",
    year: "2020",
    season: "1 Season",
    language: "7 Languages",
    rating: "U/A 12+",
    description:
      "When Netra Patil (Rinku Rajguru) faces a terminal illness and learns she has just one hundred days to live instead of giving in to despair, she partners with the determined ACP Saumya Shukla (Lara Dutta) as an undercover agent. Together, they plunge into a high-stakes world of suspense and action, racing against time to achieve their goals. Hundred delivers action, suspense, and hilariously unexpected twists, making it a thrilling and refreshing rollercoaster of a journey.",
    genres: ["Action", "Adventure"],
    starring: ["Rinku Rajguru", "Lara Dutta", "Makrand Deshpande"],
    director: ["Ruchi Narain", "Ashutosh Shah", "Taher Shabbir"],
  },
];

export const documentaries = [
  {
    id: 1,
    videoId: 281262645,
    url: "https://vimeo.com/281262645",
    thumbnail: "/category/documentaries/1.jpeg",
    src: "/category/documentaries/1.jpeg",
    title: "/images/753845722_karmma_calling.png",
    content: "Retrospective Film on Balkrishna Doshi",
    year: "2024",
    season: "1 Season",
    language: "7 Languages",
    rating: "U/A 16+",
    description:
      "This documentary explores the life and legacy of Balkrishna Vithaldas Doshi, India’s first Pritzker-winning architect, highlighting his visionary, empathetic, and sustainable designs.",
    genres: ["Thriller", "Adventure"],
    starring: ["Pankaj Tripathi", "Taher Shabbir"], // Added starring
    director: "Ashutosh Shah", // Added director
  },
  {
    id: 2,
    videoId: 281262645,
    url: "https://vimeo.com/281262645",
    thumbnail: "/category/documentaries/3.jpeg",
    src: "/category/documentaries/3.jpeg",
    title: "/images/753845722_karmma_calling.png",
    content: "Retrospective Film on Balkrishna Doshi",
    year: "2024",
    season: "1 Season",
    language: "7 Languages",
    rating: "U/A 16+",
    description:
      "This documentary explores the life and legacy of Balkrishna Vithaldas Doshi, India’s first Pritzker-winning architect, highlighting his visionary, empathetic, and sustainable designs.",
    genres: ["Drama", "Action"],
    starring: "", // Blank starring
    director: "Ruchi Narain", // Added director
  },
  {
    id: 3,
    videoId: 281262645,
    url: "https://vimeo.com/281262645",
    thumbnail: "/category/documentaries/2.jpeg",
    src: "/category/documentaries/2.jpeg",
    title: "/images/753845722_karmma_calling.png",
    content: "Retrospective Film on Balkrishna Doshi",
    year: "2024",
    season: "1 Season",
    language: "7 Languages",
    rating: "U/A 12+",
    description:
      "This documentary explores the life and legacy of Balkrishna Vithaldas Doshi, India’s first Pritzker-winning architect, highlighting his visionary, empathetic, and sustainable designs.",
    genres: ["Action", "Adventure"],
    starring: "", // Blank starring
    director: "", // Blank director
  },
  {
    id: 4,
    videoId: 281262645,
    url: "https://vimeo.com/281262645",
    thumbnail: "/category/documentaries/2.jpeg",
    src: "/category/documentaries/2.jpeg",
    title: "/images/753845722_karmma_calling.png",
    content: "New Release",
    year: "2024",
    season: "1 Season",
    language: "7 Languages",
    rating: "U/A 16+",
    description:
      "This documentary explores the life and legacy of Balkrishna Vithaldas Doshi, India’s first Pritzker-winning architect, highlighting his visionary, empathetic, and sustainable designs.",
    genres: ["Drama", "Thriller"],
    starring: "", // Blank starring
    director: "", // Blank director
  },
  // Add more objects as needed
];

export const Allcommercials = [
  {
    id: 1,
    name: "Karma Calling",
    videoId: 333499420,
    url: "https://vimeo.com/333499420",
    thumbnail: "/category/commercials/1.png",
    src: "/images/753845722_karmma_calling.png",
    title: "/category/commercials/1.png",
    content: "Karma Calling",
    year: "2024",
    season: "",
    language: "English",
    rating: "U/A 16+",
    description: "Nothing matters when the world is at your feet.",
    genres: ["Drama", "Thriller"],
    starring: ["Actor 1", "Actor 2"],
    director: "Director Name",
  },
  {
    id: 2,
    name: "The Witcher: Blood Origin",
    videoId: 293940724,
    url: "https://vimeo.com/293940724",
    thumbnail: "/category/commercials/8.jpeg",
    src: "/category/commercials/8.jpeg",
    title: "/images/witcher_blood_origin.png",
    content: "The Witcher: Blood Origin",
    year: "2024",
    season: "",
    language: "English",
    rating: "U/A 16+",
    description: "Explore the origins of the Witcher universe.",
    genres: ["Fantasy", "Adventure"],
    starring: ["Actor A", "Actor B"],
    director: "Director Name",
  },
  {
    id: 3,
    name: "Spider-Man: A New Beginning",
    videoId: 291681025,
    url: "https://vimeo.com/291681025",
    thumbnail: "/category/commercials/10.jpeg",
    src: "/category/commercials/10.jpeg",
    title: "/images/spiderman_new_beginning.png",
    content: "Spider-Man: A New Beginning",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "A thrilling reboot of the Spider-Man franchise.",
    genres: ["Action", "Superhero"],
    starring: ["Tom Holland", "Zendaya"],
    director: "Jon Watts",
  },
  {
    id: 4,
    name: "The Amazing Journey",
    videoId: 291681026,
    url: "https://vimeo.com/291681026",
    thumbnail: "/category/commercials/11.jpeg",
    src: "/category/commercials/11.jpeg",
    title: "/images/amazing_journey.png",
    content: "The Amazing Journey",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Experience an epic adventure filled with twists.",
    genres: ["Adventure", "Fantasy"],
    starring: ["Actor X", "Actor Y"],
    director: "Director Name",
  },
  {
    id: 5,
    name: "The Lost Treasure",
    videoId: 290693753,
    url: "https://vimeo.com/290693753",
    thumbnail: "/category/commercials/14.jpeg",
    src: "/category/commercials/14.jpeg",
    title: "/images/lost_treasure.png",
    content: "The Lost Treasure",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Follow the quest to find the lost treasure of ancient times.",
    genres: ["Adventure", "Mystery"],
    starring: ["Actor C", "Actor D"],
    director: "Director Name",
  },
  {
    id: 6,
    name: "The Dark Secrets",
    videoId: 293940725,
    url: "https://vimeo.com/293940725",
    thumbnail: "/category/commercials/15.jpeg",
    src: "/category/commercials/15.jpeg",
    title: "/images/dark_secrets.png",
    content: "The Dark Secrets",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Unravel the mysteries that lie hidden in the shadows.",
    genres: ["Thriller", "Horror"],
    starring: ["Actor E", "Actor F"],
    director: "Director Name",
  },
];

export const Allcommercialsinnerpage = [
  {
    id: 1,
    name: "Snicker's Veerappan",
    videoId: 278664507,
    url: "https://vimeo.com/278664507",
    thumbnail: "/category/commercials/1.png",
    src: "/category/commercials/1.png",
    title: "/images/1.jpeg",
    content: "Snicker's Veerappan",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of nature and literacy.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 2,
    name: "Maruti Suzuki Vitara Brezza",
    videoId: 693482697,
    url: "https://vimeo.com/693482697",
    thumbnail: "/category/commercials/2.png",
    src: "/category/commercials/2.png",
    title: "/images/2.jpeg",
    content: "Maruti Suzuki Vitara Brezza",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of nature and literacy.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 3,
    name: "The Divide - Social experiment",
    videoId: 520815980,
    url: "https://vimeo.com/520815980",
    thumbnail: "/category/commercials/3.png",
    src: "/category/commercials/3.png",
    title: "/images/3.jpeg",
    content: "The Divide - Social experiment",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of nature and literacy.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 4,
    name: "Grants",
    videoId: 878234531,
    url: "https://vimeo.com/878234531",
    thumbnail: "/category/commercials/4.png",
    src: "/category/commercials/4.png",
    title: "/images/4.jpeg",
    content: "Grants",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of nature and literacy.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 5,
    name: "Havells Appliances",
    videoId: 878238516,
    url: "https://vimeo.com/878238516",
    thumbnail: "/category/commercials/5.png",
    src: "/category/commercials/5.png",
    title: "/images/5.jpeg",
    content: "Havells Appliances",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of nature and literacy.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 6,
    name: "Standard Electricals",
    videoId: null,
    url: "",
    thumbnail: "/category/commercials/6.png",
    src: "/category/commercials/6.png",
    title: "/images/6.jpeg",
    content: "Standard Electricals",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of nature and literacy.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 7,
    name: "Vadilal Hunk",
    videoId: 538105209,
    url: "https://vimeo.com/538105209",
    thumbnail: "/category/commercials/7.png",
    src: "/category/commercials/7.png",
    title: "/images/dark_secrets.png",
    content: "Vadilal Hunk",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Unravel the mysteries that lie hidden in the shadows.",
    genres: ["Thriller", "Horror"],
    starring: ["Actor E", "Actor F"],
    director: "Director Name",
  },
  {
    id: 8,
    name: "Magic Bricks Home Loan - Ayushmaan",
    videoId: 687411427,
    url: "https://vimeo.com/687411427",
    thumbnail: "/category/commercials/8.png",
    src: "/category/commercials/8.png",
    title: "/images/dark_secrets.png",
    content: "Magic Bricks Home Loan - Ayushmaan",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Unravel the mysteries that lie hidden in the shadows.",
    genres: ["Thriller", "Horror"],
    starring: ["Actor E", "Actor F"],
    director: "Director Name",
  },
  {
    id: 9,
    name: "Magic Bricks Prime Home Ayushman + Aparshakti",
    // dummy
    videoId: 293940725,
    url: "https://vimeo.com/293940725",
    // dummy
    thumbnail: "/category/commercials/9.png",
    src: "/category/commercials/9.png",
    title: "/images/dark_secrets.png",
    content: "Magic Bricks Prime Home Ayushman + Aparshakti",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Unravel the mysteries that lie hidden in the shadows.",
    genres: ["Thriller", "Horror"],
    starring: ["Actor E", "Actor F"],
    director: "Director Name",
  },
  {
    id: 10,
    name: "Magic Bricks Manifesto- Ayushman",
    videoId: 679918649,
    url: "https://vimeo.com/679918649",
    thumbnail: "/category/commercials/10.png",
    src: "/category/commercials/10.png",
    title: "/images/dark_secrets.png",
    content: "Magic Bricks Manifesto- Ayushman",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Unravel the mysteries that lie hidden in the shadows.",
    genres: ["Thriller", "Horror"],
    starring: ["Actor E", "Actor F"],
    director: "Director Name",
  },
  {
    id: 11,
    name: "Magic Bricks Advice- Ayushman",
    videoId: 687403624,
    url: "https://vimeo.com/687403624",
    thumbnail: "/category/commercials/11.png",
    src: "/category/commercials/11.png",
    title: "/images/dark_secrets.png",
    content: "Magic Bricks Advice- Ayushman",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Unravel the mysteries that lie hidden in the shadows.",
    genres: ["Thriller", "Horror"],
    starring: ["Actor E", "Actor F"],
    director: "Director Name",
  },
  {
    id: 12,
    name: "Vadilal Seema Aunty",
    // dummy
    videoId: 293940725,
    url: "https://vimeo.com/293940725",
    // dummy
    thumbnail: "/category/commercials/12.png",
    src: "/category/commercials/12.png",
    title: "/images/dark_secrets.png",
    content: "Vadilal Seema Aunty",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Unravel the mysteries that lie hidden in the shadows.",
    genres: ["Thriller", "Horror"],
    starring: ["Actor E", "Actor F"],
    director: "Director Name",
  },

  {
    id: 13,
    name: "Magic Bricks Pay Rent- Ayushman",
    // dummy
    videoId: 293940725,
    url: "https://vimeo.com/293940725",
    // dummy
    thumbnail: "/category/commercials/13.png",
    src: "/category/commercials/13.png",
    title: "/images/dark_secrets.png",
    content: "Magic Bricks Pay Rent- Ayushman",
    year: "2024",
    season: "1 Season",
    language: "English",
    rating: "U/A 16+",
    description: "Unravel the mysteries that lie hidden in the shadows.",
    genres: ["Thriller", "Horror"],
    starring: ["Actor E", "Actor F"],
    director: "Director Name",
  },
  {
    id: 14,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 538102928,
    url: "https://vimeo.com/538102928",
    thumbnail: "/category/commercials/14.png",
    src: "/category/commercials/14.png",
    title: "/images/ice_cream.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A delightful journey through the world of ice cream.",
    genres: ["Food", "Lifestyle"],
    starring: ["Daisy Shah"],
    director: "Director Name",
  },
  {
    id: 15,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 538104280,
    url: "https://vimeo.com/538104280",
    thumbnail: "/category/commercials/15.png",
    src: "/category/commercials/15.png",
    title: "/images/party.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Celebrate every moment with Vadilal.",
    genres: ["Food", "Lifestyle"],
    starring: ["Actor G", "Actor H"],
    director: "Director Name",
  },
  {
    id: 16,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 538103429,
    url: "https://vimeo.com/538103429",
    thumbnail: "/category/commercials/16.png",
    src: "/category/commercials/16.png",
    title: "/images/music.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Feel the rhythm of life with Vadilal.",
    genres: ["Music", "Lifestyle"],
    starring: ["Actor I", "Actor J"],
    director: "Director Name",
  },
  {
    id: 17,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 538103837,
    url: "https://vimeo.com/538103837",
    thumbnail: "/category/commercials/17.png",
    src: "/category/commercials/17.png",
    title: "/images/office.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Bringing joy to your workplace.",
    genres: ["Lifestyle", "Corporate"],
    starring: ["Actor K", "Actor L"],
    director: "Director Name",
  },
  {
    id: 18,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 538104749,
    url: "https://vimeo.com/538104749",
    thumbnail: "/category/commercials/18.png",
    src: "/category/commercials/18.png",
    title: "/images/proposal.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Sweet moments with Vadilal.",
    genres: ["Romance", "Lifestyle"],
    starring: ["Actor M", "Actor N"],
    director: "Director Name",
  },
  {
    id: 19,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 334713654,
    url: "https://vimeo.com/334713654",
    thumbnail: "/category/commercials/19.png",
    src: "/category/commercials/19.png",
    title: "/images/tyre.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Experience the grip of JK Tyre.",
    genres: ["Automotive", "Lifestyle"],
    starring: ["Actor O", "Actor P"],
    director: "Director Name",
  },
  {
    id: 20,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 692139698,
    url: "https://vimeo.com/692139698",
    thumbnail: "/category/commercials/20.png",
    src: "/category/commercials/20.png",
    title: "/images/alphonso.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Savor the taste of Alphonso.",
    genres: ["Food", "Lifestyle"],
    starring: ["Actor Q", "Actor R"],
    director: "Director Name",
  },
  {
    id: 21,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 878260483,
    url: "https://vimeo.com/878260483",
    thumbnail: "/category/commercials/21.png",
    src: "/category/commercials/21.png",
    title: "/images/rasmalai.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Indulge in the richness of Kesar rasmalai.",
    genres: ["Food", "Lifestyle"],
    starring: ["Actor S", "Actor T"],
    director: "Director Name",
  },
  {
    id: 22,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 878282180,
    url: "https://vimeo.com/878282180",
    thumbnail: "/category/commercials/22.png",
    src: "/category/commercials/22.png",
    title: "/images/falooda.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A refreshing treat for every occasion.",
    genres: ["Food", "Lifestyle"],
    starring: ["Actor U", "Actor V"],
    director: "Director Name",
  },
  {
    id: 23,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 333499921,
    url: "https://vimeo.com/333499921",
    thumbnail: "/category/commercials/24.png",
    src: "/category/commercials/24.png",
    title: "/images/daddy.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Celebrating the bond between father and child.",
    genres: ["Family", "Lifestyle"],
    starring: ["Actor W", "Actor X"],
    director: "Director Name",
  },
  {
    id: 24,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 333499420,
    url: "https://vimeo.com/333499420",
    thumbnail: "/category/commercials/25.png",
    src: "/category/commercials/25.png",
    title: "/images/jugalbandi.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A harmonious blend of tradition and modernity.",
    genres: ["Family", "Lifestyle"],
    starring: ["Actor Y", "Actor Z"],
    director: "Director Name",
  },
  {
    id: 25,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 330038024,
    url: "https://vimeo.com/330038024",
    thumbnail: "/category/commercials/26.png",
    src: "/category/commercials/26.png",
    title: "/images/father.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A heartwarming journey of fatherhood.",
    genres: ["Family", "Drama"],
    starring: ["Actor AA", "Actor BB"],
    director: "Director Name",
  },
  {
    id: 26,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 330035722,
    url: "https://vimeo.com/330035722",
    thumbnail: "/category/commercials/27.png",
    src: "/category/commercials/27.png",
    title: "/images/investment.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Invest wisely with IndusInd Bank.",
    genres: ["Finance", "Lifestyle"],
    starring: ["Actor CC", "Actor DD"],
    director: "Director Name",
  },
  {
    id: 27,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 330036411,
    url: "https://vimeo.com/330036411",
    thumbnail: "/category/commercials/28.png",
    src: "/category/commercials/28.png",
    title: "/images/friend.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Innovation that brings people closer.",
    genres: ["Finance", "Lifestyle"],
    starring: ["Actor EE", "Actor FF"],
    director: "Director Name",
  },
  {
    id: 28,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 330037191,
    url: "https://vimeo.com/330037191",
    thumbnail: "/category/commercials/29.png",
    src: "/category/commercials/29.png",
    title: "/images/development.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Empowering small businesses with IndusInd Bank.",
    genres: ["Finance", "Lifestyle"],
    starring: ["Actor GG", "Actor HH"],
    director: "Director Name",
  },
  {
    id: 29,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 330035213,
    url: "https://vimeo.com/330035213",
    thumbnail: "/category/commercials/30.png",
    src: "/category/commercials/30.png",
    title: "/images/gold.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Secure your future with IndusInd Bank Gold.",
    genres: ["Finance", "Lifestyle"],
    starring: ["Actor II", "Actor JJ"],
    director: "Director Name",
  },
  {
    id: 30,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 330034963,
    url: "https://vimeo.com/330034963",
    thumbnail: "/category/commercials/31.png",
    src: "/category/commercials/31.png",
    title: "/images/cafe.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2022",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A cozy corner for your financial needs.",
    genres: ["Finance", "Lifestyle"],
    starring: ["Actor KK", "Actor LL"],
    director: "Director Name",
  },
  {
    id: 31,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 280711122,
    url: "https://vimeo.com/280711122",
    thumbnail: "/category/commercials/32.png",
    src: "/category/commercials/32.png",
    title: "/images/embarrassed.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2021",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A humorous take on everyday embarrassments.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor MM", "Actor NN"],
    director: "Director Name",
  },
  {
    id: 32,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 276705935,
    url: "https://vimeo.com/276705935",
    thumbnail: "/category/commercials/33.png",
    src: "/category/commercials/33.png",
    title: "/images/astronaut.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2021",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A cosmic journey with Vadilal.",
    genres: ["Sci-Fi", "Lifestyle"],
    starring: ["Actor OO", "Actor PP"],
    director: "Director Name",
  },
  {
    id: 33,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 275635879,
    url: "https://vimeo.com/275635879",
    thumbnail: "/category/commercials/34.png",
    src: "/category/commercials/34.png",
    title: "/images/misunderstood.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2021",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of misunderstandings and resolutions.",
    genres: ["Drama", "Lifestyle"],
    starring: ["Actor QQ", "Actor RR"],
    director: "Director Name",
  },
  {
    id: 34,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 280710291,
    url: "https://vimeo.com/280710291",
    thumbnail: "/category/commercials/35.png",
    src: "/category/commercials/35.png",
    title: "/images/hot_guy.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2021",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "The coolest guy in town.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 35,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 693479363,
    url: "https://vimeo.com/693479363",
    thumbnail: "/category/commercials/36.png",
    src: "/category/commercials/36.png",
    title: "/images/zid.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A story of determination and brilliance.",
    genres: ["Drama", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 36,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 693479289,
    url: "https://vimeo.com/693479289",
    thumbnail: "/category/commercials/37.png",
    src: "/category/commercials/36.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 37,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 693479149,
    url: "https://vimeo.com/693479149",
    thumbnail: "/category/commercials/38.png",
    src: "/category/commercials/38.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 38,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 693478996,
    url: "https://vimeo.com/693478996",
    thumbnail: "/category/commercials/38.jpeg",
    src: "/category/commercials/38.jpeg",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 38,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 693479205,
    url: "https://vimeo.com/693479205",
    thumbnail: "/category/commercials/40.png",
    src: "/category/commercials/40.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 39,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 693478782,
    url: "https://vimeo.com/693478782",
    thumbnail: "/category/commercials/41.png",
    src: "/category/commercials/41.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 40,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 693478878,
    url: "https://vimeo.com/693478878",
    thumbnail: "/category/commercials/42.png",
    src: "/category/commercials/42.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 41,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 693478943,
    url: "https://vimeo.com/693478943",
    thumbnail: "/category/commercials/43.png",
    src: "/category/commercials/43.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 42,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 275638020,
    url: "https://vimeo.com/275638020",
    thumbnail: "/category/commercials/44.png",
    src: "/category/commercials/44.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 43,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 276706925,
    url: "https://vimeo.com/276706925",
    thumbnail: "/category/commercials/45.png",
    src: "/category/commercials/45.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 44,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 275631797,
    url: "https://vimeo.com/275631797",
    thumbnail: "/category/commercials/46.png",
    src: "/category/commercials/46.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 45,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 275618855,
    url: "https://vimeo.com/275618855",
    thumbnail: "/category/commercials/47.png",
    src: "/category/commercials/47.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 46,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 275596972,
    url: "https://vimeo.com/275596972",
    thumbnail: "/category/commercials/48.png",
    src: "/category/commercials/48.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 47,
    name: "Vadilal Ice cream - Daisy Shah",
    videoId: 275383393,
    url: "https://vimeo.com/275383393",
    thumbnail: "/category/commercials/49.png",
    src: "/category/commercials/49.png",
    title: "/images/tall_man.png",
    content: "Vadilal Ice cream - Daisy Shah",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 48,
    name: "Vestar AC- Irfaan Khan",
    videoId: 278667113,
    url: "https://vimeo.com/278667113",
    thumbnail: "/category/commercials/50.png",
    src: "/category/commercials/50.png",
    title: "/images/tall_man.png",
    content: "Vestar AC- Irfaan Khan",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 49,
    name: "Snickers - Tubelight",
    videoId: 275628697,
    url: "https://vimeo.com/275628697",
    thumbnail: "/category/commercials/51.png",
    src: "/category/commercials/51.png",
    title: "/images/tall_man.png",
    content: "Snickers - Tubelight",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 50,
    name: "Vadilal Friend Zone",
    videoId: 276703567,
    url: "https://vimeo.com/276703567",
    thumbnail: "/category/commercials/52.png",
    src: "/category/commercials/52.png",
    title: "/images/tall_man.png",
    content: "Vadilal Friend Zone",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tall tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 51,
    name: "Snickers - Confused",
    videoId: 275630564,
    url: "https://vimeo.com/275630564",
    thumbnail: "/category/commercials/53.png",
    src: "/category/commercials/53.png",
    title: "/images/confused.png",
    content: "Snickers - Confused",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of confusion and clarity.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor YY", "Actor ZZ"],
    director: "Director Name",
  },
  {
    id: 52,
    name: "Snickers - Sarcastic",
    videoId: 281256800,
    url: "https://vimeo.com/281256800",
    thumbnail: "/category/commercials/54.png",
    src: "/category/commercials/54.png",
    title: "/images/sarcastic.png",
    content: "Snickers - Sarcastic",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A sarcastic twist to brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor AA", "Actor BB"],
    director: "Director Name",
  },
  {
    id: 53,
    name: "Snickers - Princess",
    videoId: 281256813,
    url: "https://vimeo.com/281256813",
    thumbnail: "/category/commercials/55.png",
    src: "/category/commercials/55.png",
    title: "/images/princess.png",
    content: "Snickers - Princess",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A royal tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor CC", "Actor DD"],
    director: "Director Name",
  },
  {
    id: 54,
    name: "Vadilal Gourmet natural Gulab Jamun",
    videoId: null,
    url: "",
    thumbnail: "/category/commercials/56.png",
    src: "/category/commercials/56.png",
    title: "/images/gulab_jamun.png",
    content: "Vadilal Gourmet natural Gulab Jamun",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A sweet tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor EE", "Actor FF"],
    director: "Director Name",
  },
  {
    id: 55,
    name: "Vadilal Gourmet natural alphonso",
    videoId: null,
    url: "",
    thumbnail: "/category/commercials/57.png",
    src: "/category/commercials/57.png",
    title: "/images/alphonso.png",
    content: "Vadilal Gourmet natural alphonso",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A fruity tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor GG", "Actor HH"],
    director: "Director Name",
  },
  {
    id: 56,
    name: "Adda52 - Chris Gayle",
    videoId: 294744410,
    url: "https://vimeo.com/294744410",
    thumbnail: "/category/commercials/58.png",
    src: "/category/commercials/58.png",
    title: "/images/chris_gayle.png",
    content: "Adda52 - Chris Gayle",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A cricketing tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor II", "Actor JJ"],
    director: "Director Name",
  },
  {
    id: 57,
    name: "Hyundai Brilliant Moments - Birthday",
    videoId: 693465086,
    url: "https://vimeo.com/693465086",
    thumbnail: "/category/commercials/58.jpeg",
    src: "/category/commercials/57.jpeg",
    title: "/images/birthday.png",
    content: "Hyundai Brilliant Moments - Birthday",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A celebratory tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor KK", "Actor LL"],
    director: "Director Name",
  },
  {
    id: 58,
    name: "Hyundai Brilliant Moments - Rain",
    videoId: 693479064,
    url: "https://vimeo.com/693479064",
    thumbnail: "/category/commercials/59.jpeg",
    src: "/category/commercials/58.jpeg",
    title: "/images/rain.png",
    content: "Hyundai Brilliant Moments - Rain",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A rainy tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor MM", "Actor NN"],
    director: "Director Name",
  },
  {
    id: 59,
    name: "Snickers - Nautanki",
    videoId: 275634653,
    url: "https://vimeo.com/275634653",
    thumbnail: "/category/commercials/60.jpeg",
    src: "/category/commercials/59.jpeg",
    title: "/images/nautanki.png",
    content: "Snickers - Nautanki",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A dramatic tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor OO", "Actor PP"],
    director: "Director Name",
  },
  {
    id: 60,
    name: "Hyundai Naamkaran Dadiji",
    videoId: 693479411,
    url: "https://vimeo.com/693479411",
    thumbnail: "/category/commercials/61.jpeg",
    src: "/category/commercials/60.jpeg",
    title: "/images/dadiji.png",
    content: "Hyundai Naamkaran Dadiji",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A family tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor QQ", "Actor RR"],
    director: "Director Name",
  },
  {
    id: 61,
    name: "Hyundai Naamkaran Panditji",
    videoId: 693479463,
    url: "https://vimeo.com/693479463",
    thumbnail: "/category/commercials/62.jpeg",
    src: "/category/commercials/61.jpeg",
    title: "/images/panditji.png",
    content: "Hyundai Naamkaran Panditji",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A spiritual tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 62,
    name: "Caprese SS’15 Alia Bhatt",
    videoId: null,
    url: "",
    thumbnail: "/category/commercials/64.png",
    src: "/category/commercials/62.jpeg",
    title: "/images/alia_bhatt.png",
    content: "Caprese SS’15 Alia Bhatt",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A fashionable tale of brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 63,
    name: "Somany Beti",
    videoId: 275625448,
    url: "https://vimeo.com/275625448",
    thumbnail: "/category/commercials/64.jpeg",
    src: "/category/commercials/64.jpeg",
    title: "/images/beti.png",
    content: "Somany Beti",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of family and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 64,
    name: "Magic Bricks Choice",
    videoId: 278664351,
    url: "https://vimeo.com/278664351",
    thumbnail: "/category/commercials/65.jpeg",
    src: "/category/commercials/64.jpeg",
    title: "/images/choice.png",
    content: "Magic Bricks Choice",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of making the right choice.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor YY", "Actor ZZ"],
    director: "Director Name",
  },
  {
    id: 65,
    name: "Fena- Preity Zinta",
    videoId: 521257091,
    url: "https://vimeo.com/521257091",
    thumbnail: "/category/commercials/66.jpeg",
    src: "/category/commercials/65.jpeg",
    title: "/images/preity_zinta.png",
    content: "Fena- Preity Zinta",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of elegance and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor AA", "Actor BB"],
    director: "Director Name",
  },
  {
    id: 66,
    name: "Lloyd Unisex",
    videoId: 275632767,
    url: "https://vimeo.com/275632767",
    thumbnail: "/category/commercials/67.jpeg",
    src: "/category/commercials/66.jpeg",
    title: "/images/unisex.png",
    content: "Lloyd Unisex",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of style and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor CC", "Actor DD"],
    director: "Director Name",
  },
  {
    id: 67,
    name: "Magic Bricks- Squirrel",
    videoId: 278666438,
    url: "https://vimeo.com/278666438",
    thumbnail: "/category/commercials/68.jpeg",
    src: "/category/commercials/67.jpeg",
    title: "/images/squirrel.png",
    content: "Magic Bricks- Squirrel",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of nature and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor EE", "Actor FF"],
    director: "Director Name",
  },
  {
    id: 68,
    name: "Magic Bricks Bird House",
    videoId: 278666788,
    url: "https://vimeo.com/278666788",
    thumbnail: "/category/commercials/69.jpeg",
    src: "/category/commercials/68.jpeg",
    title: "/images/bird_house.png",
    content: "Magic Bricks Bird House",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of birds and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor GG", "Actor HH"],
    director: "Director Name",
  },
  {
    id: 69,
    name: "Lloyd Laughter",
    videoId: 275601276,
    url: "https://vimeo.com/275601276",
    thumbnail: "/category/commercials/70.jpeg",
    src: "/category/commercials/69.jpeg",
    title: "/images/laughter.png",
    content: "Lloyd Laughter",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of joy and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor II", "Actor JJ"],
    director: "Director Name",
  },
  {
    id: 70,
    name: "Lloyd TV- Shruti Hassan",
    videoId: 275595412,
    url: "https://vimeo.com/275595412",
    thumbnail: "/category/commercials/71.jpeg",
    src: "/category/commercials/70.jpeg",
    title: "/images/shruti_hassan.png",
    content: "Lloyd TV- Shruti Hassan",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of entertainment and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor KK", "Actor LL"],
    director: "Director Name",
  },
  {
    id: 71,
    name: "Freedom Oil Hindi",
    videoId: 275609746,
    url: "https://vimeo.com/275609746",
    thumbnail: "/category/commercials/72.jpeg",
    src: "/category/commercials/71.jpeg",
    title: "/images/freedom_oil.png",
    content: "Freedom Oil Hindi",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of health and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor MM", "Actor NN"],
    director: "Director Name",
  },
  {
    id: 72,
    name: "Immunization Music Video",
    videoId: 275590716,
    url: "https://vimeo.com/275590716",
    thumbnail: "/category/commercials/73.jpeg",
    src: "/category/commercials/72.jpeg",
    title: "/images/immunization.png",
    content: "Immunization Music Video",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of health and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor OO", "Actor PP"],
    director: "Director Name",
  },
  {
    id: 73,
    name: "Shiksha ka Suraj",
    videoId: 275380666,
    url: "https://vimeo.com/275380666",
    thumbnail: "/category/commercials/74.jpeg",
    src: "/category/commercials/73.jpeg",
    title: "/images/shiksha.png",
    content: "Shiksha ka Suraj",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of education and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor QQ", "Actor RR"],
    director: "Director Name",
  },
  {
    id: 74,
    name: "Accident-National Literacy Mission",
    videoId: 275383595,
    url: "https://vimeo.com/275383595",
    thumbnail: "/category/commercials/75.jpeg",
    src: "/category/commercials/74.jpeg",
    title: "/images/accident.png",
    content: "Accident-National Literacy Mission",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of literacy and brilliance.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 75,
    name: "Forest Film- National Literacy Mission",
    videoId: 275251247,
    url: "https://vimeo.com/275251247",
    thumbnail: "/category/commercials/76.jpeg",
    src: "/category/commercials/75.jpeg",
    title: "/images/forest_film.png",
    content: "Forest Film- National Literacy Mission",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of nature and literacy.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor UU", "Actor VV"],
    director: "Director Name",
  },
  {
    id: 76,
    name: "Fisherman- National Literacy Mission",
    videoId: 275603070,
    url: "https://vimeo.com/275603070",
    thumbnail: "/category/commercials/77.jpeg",
    src: "/category/commercials/76.jpeg",
    title: "/images/fisherman.png",
    content: "Fisherman- National Literacy Mission",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A story of literacy and the sea.",
    genres: ["Drama", "Inspirational"],
    starring: ["Actor WW", "Actor XX"],
    director: "Director Name",
  },
  {
    id: 77,
    name: "Kelloggs All Bran- Karisma Kapoor",
    videoId: 275246527,
    url: "https://vimeo.com/275246527",
    thumbnail: "/category/commercials/78.jpeg",
    src: "/category/commercials/77.jpeg",
    title: "/images/kelloggs_all_bran.png",
    content: "Kelloggs All Bran- Karisma Kapoor",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A healthy start to your day.",
    genres: ["Health", "Lifestyle"],
    starring: ["Karisma Kapoor"],
    director: "Director Name",
  },
  {
    id: 78,
    name: "Kellogs All Bran - Tisca Chopra Socks",
    videoId: 275587296,
    url: "https://vimeo.com/275587296",
    thumbnail: "/category/commercials/79_.jpeg",
    src: "/category/commercials/78.jpeg",
    title: "/images/kelloggs_all_bran_socks.png",
    content: "Kellogs All Bran - Tisca Chopra Socks",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A quirky take on healthy living.",
    genres: ["Comedy", "Health"],
    starring: ["Tisca Chopra"],
    director: "Director Name",
  },
  {
    id: 79,
    name: "Kellogs All Bran - Tisca Chopra",
    videoId: null, // No Vimeo ID provided in the sheet
    url: "",
    thumbnail: "/category/commercials/85.jpeg",
    src: "/category/commercials/79.jpeg",
    title: "/images/kelloggs_all_bran_tisca.png",
    content: "Kellogs All Bran - Tisca Chopra",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A healthy lifestyle with Tisca Chopra.",
    genres: ["Health", "Lifestyle"],
    starring: ["Tisca Chopra"],
    director: "Director Name",
  },
  {
    id: 80,
    name: "Bodygaurd Intro– Kareena",
    videoId: 275384878,
    url: "https://vimeo.com/275384878",
    thumbnail: "/category/commercials/81.jpeg",
    src: "/category/commercials/85.jpeg",
    title: "/images/bodyguard_intro.png",
    content: "Bodygaurd Intro– Kareena",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "An introduction to the world of Bodyguard.",
    genres: ["Action", "Drama"],
    starring: ["Kareena Kapoor"],
    director: "Director Name",
  },
  {
    id: 81,
    name: "Phillips - Kareena",
    videoId: 275595535,
    url: "https://vimeo.com/275595535",
    thumbnail: "/category/commercials/82.jpeg",
    src: "/category/commercials/81.jpeg",
    title: "/images/phillips_kareena.png",
    content: "Phillips - Kareena",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A stylish take on home appliances.",
    genres: ["Lifestyle", "Technology"],
    starring: ["Kareena Kapoor"],
    director: "Director Name",
  },
  {
    id: 82,
    name: "Pedia Sure",
    videoId: 275593715,
    url: "https://vimeo.com/275593715",
    thumbnail: "/category/commercials/83.jpeg",
    src: "/category/commercials/82.jpeg",
    title: "/images/pedia_sure.png",
    content: "Pedia Sure",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Ensuring your child's health and growth.",
    genres: ["Health", "Family"],
    starring: ["Actor YY", "Actor ZZ"],
    director: "Director Name",
  },
  {
    id: 83,
    name: "LIC Basketball",
    videoId: 275594362,
    url: "https://vimeo.com/275594362",
    thumbnail: "/category/commercials/84.jpeg",
    src: "/category/commercials/83.jpeg",
    title: "/images/lic_basketball.png",
    content: "LIC Basketball",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A game of life and insurance.",
    genres: ["Sports", "Drama"],
    starring: ["Actor AA", "Actor BB"],
    director: "Director Name",
  },
  {
    id: 84,
    name: "LIC- Children's plan",
    videoId: 281268768,
    url: "https://vimeo.com/281268768",
    thumbnail: "/category/commercials/85.jpeg",
    src: "/category/commercials/84.jpeg",
    title: "/images/lic_childrens_plan.png",
    content: "LIC- Children's plan",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Securing your child's future.",
    genres: ["Family", "Finance"],
    starring: ["Actor CC", "Actor DD"],
    director: "Director Name",
  },
  {
    id: 85,
    name: "Colgate",
    videoId: 275597550,
    url: "https://vimeo.com/275597550",
    thumbnail: "/category/commercials/86.jpeg",
    src: "/category/commercials/85.jpeg",
    title: "/images/colgate.png",
    content: "Colgate",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Bright smiles with Colgate.",
    genres: ["Health", "Lifestyle"],
    starring: ["Actor EE", "Actor FF"],
    director: "Director Name",
  },
  {
    id: 86,
    name: "Magic Bricks Do deewane- Amit Sadh",
    videoId: 275594220,
    url: "https://vimeo.com/275594220",
    thumbnail: "/category/commercials/87.jpeg",
    src: "/category/commercials/86.jpeg",
    title: "/images/magic_bricks_do_deewane.png",
    content: "Magic Bricks Do deewane- Amit Sadh",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tale of two dreamers.",
    genres: ["Drama", "Romance"],
    starring: ["Amit Sadh"],
    director: "Director Name",
  },
  {
    id: 87,
    name: "Magic Bricks IPL - Amit Sadh, Varun Sharma",
    videoId: 275595323,
    url: "https://vimeo.com/275595323",
    thumbnail: "/category/commercials/88.jpeg",
    src: "/category/commercials/87.jpeg",
    title: "/images/magic_bricks_ipl.png",
    content: "Magic Bricks IPL - Amit Sadh, Varun Sharma",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Cricket and homes, a perfect match.",
    genres: ["Sports", "Comedy"],
    starring: ["Amit Sadh", "Varun Sharma"],
    director: "Director Name",
  },
  {
    id: 88,
    name: "Magic Bricks Advice- Varun Sharma",
    videoId: 275599854,
    url: "https://vimeo.com/275599854",
    thumbnail: "/category/commercials/89.jpeg",
    src: "/category/commercials/88.jpeg",
    title: "/images/magic_bricks_advice.png",
    content: "Magic Bricks Advice- Varun Sharma",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Expert advice for your dream home.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Varun Sharma"],
    director: "Director Name",
  },
  {
    id: 89,
    name: "Magic Bricks Options- Varun Sharma",
    videoId: null, // No Vimeo ID provided in the sheet
    url: "",
    thumbnail: "/category/commercials/89.jpeg",
    src: "/category/commercials/89.jpeg",
    title: "/images/magic_bricks_options.png",
    content: "Magic Bricks Options- Varun Sharma",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Exploring options for your home.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Varun Sharma"],
    director: "Director Name",
  },
  {
    id: 90,
    name: "Ariel Matic",
    videoId: 275606911,
    url: "https://vimeo.com/275606911",
    thumbnail: "/category/commercials/91.jpeg",
    src: "/category/commercials/89.jpeg",
    title: "/images/ariel_matic.png",
    content: "Ariel Matic",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Tough stains, easy solutions.",
    genres: ["Lifestyle", "Family"],
    starring: ["Actor GG", "Actor HH"],
    director: "Director Name",
  },
  {
    id: 91,
    name: "Godrej",
    videoId: 278793691,
    url: "https://vimeo.com/278793691",
    thumbnail: "/category/commercials/92.jpeg",
    src: "/category/commercials/91.jpeg",
    title: "/images/godrej.png",
    content: "Godrej",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Trusted by generations.",
    genres: ["Lifestyle", "Family"],
    starring: ["Actor II", "Actor JJ"],
    director: "Director Name",
  },
  {
    id: 92,
    name: "Magic Bricks House Warming- Varun Sharma",
    videoId: null, // No Vimeo ID provided in the sheet
    url: "",
    thumbnail: "/category/commercials/101_.png",
    src: "/category/commercials/92.jpeg",
    title: "/images/magic_bricks_house_warming.png",
    content: "Magic Bricks House Warming- Varun Sharma",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Celebrating new beginnings.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Varun Sharma"],
    director: "Director Name",
  },
  {
    id: 93,
    name: "Real Juice – Sonali Bendre",
    videoId: null, // No Vimeo ID provided in the sheet
    url: "",
    thumbnail: "/category/commercials/101.jpeg",
    src: "/category/commercials/101.jpeg",
    title: "/images/real_juice.png",
    content: "Real Juice – Sonali Bendre",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Natural goodness in every sip.",
    genres: ["Health", "Lifestyle"],
    starring: ["Sonali Bendre"],
    director: "Director Name",
  },
  {
    id: 94,
    name: "VGN builders skipping",
    videoId: 275594574,
    url: "https://vimeo.com/275594574",
    thumbnail: "/category/commercials/95.jpeg",
    src: "/category/commercials/101.jpeg",
    title: "/images/vgn_builders_skipping.png",
    content: "VGN builders skipping",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Building dreams, one skip at a time.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor KK", "Actor LL"],
    director: "Director Name",
  },
  {
    id: 95,
    name: "VGN Hazel rush",
    videoId: 275602339,
    url: "https://vimeo.com/275602339",
    thumbnail: "/category/commercials/96.jpeg",
    src: "/category/commercials/95.jpeg",
    title: "/images/vgn_hazel_rush.png",
    content: "VGN Hazel rush",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A rush to the perfect home.",
    genres: ["Drama", "Lifestyle"],
    starring: ["Actor MM", "Actor NN"],
    director: "Director Name",
  },
  {
    id: 96,
    name: "VGN Tent",
    videoId: 275600661,
    url: "https://vimeo.com/275600661",
    thumbnail: "/category/commercials/97.jpeg",
    src: "/category/commercials/96.jpeg",
    title: "/images/vgn_tent.png",
    content: "VGN Tent",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Camping in style with VGN.",
    genres: ["Adventure", "Lifestyle"],
    starring: ["Actor OO", "Actor PP"],
    director: "Director Name",
  },
  {
    id: 97,
    name: "VGN builders ice cream",
    videoId: 275594709,
    url: "https://vimeo.com/275594709",
    thumbnail: "/category/commercials/98.jpeg",
    src: "/category/commercials/97.jpeg",
    title: "/images/vgn_builders_ice_cream.png",
    content: "VGN builders ice cream",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Sweet moments with VGN.",
    genres: ["Comedy", "Lifestyle"],
    starring: ["Actor QQ", "Actor RR"],
    director: "Director Name",
  },
  {
    id: 98,
    name: "Elephant House cream soda",
    videoId: 275596288,
    url: "https://vimeo.com/275596288",
    thumbnail: "/category/commercials/99.jpeg",
    src: "/category/commercials/98.jpeg",
    title: "/images/elephant_house_cream_soda.png",
    content: "Elephant House cream soda",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Refreshing moments with Elephant House.",
    genres: ["Lifestyle", "Family"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 99,
    name: "Complan",
    videoId: null, // No Vimeo ID provided in the sheet
    url: "",
    thumbnail: "/category/commercials/103.png",
    src: "/category/commercials/99.jpeg",
    title: "/images/complan.png",
    content: "Complan",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Boost your energy with Complan.",
    genres: ["Health", "Family"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 100,
    name: "Casio Father and son",
    videoId: 705340855,
    url: "https://vimeo.com/705340855",
    thumbnail: "/category/commercials/101_1.jpeg",
    src: "/category/commercials/103.jpeg",
    title: "/images/casio_father_and_son.png",
    content: "Casio Father and son",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A heartwarming story of a father and son.",
    genres: ["Family", "Drama"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 101,
    name: "Casio office",
    videoId: 705338937,
    url: "https://vimeo.com/705338937",
    thumbnail: "/category/commercials/102.jpeg",
    src: "/category/commercials/101.jpeg",
    title: "/images/casio_office.png",
    content: "Casio office",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Efficiency meets style in the office.",
    genres: ["Lifestyle", "Corporate"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 102,
    name: "Casio trader",
    videoId: 705337868,
    url: "https://vimeo.com/705337868",
    thumbnail: "/category/commercials/103.jpeg",
    src: "/category/commercials/102.jpeg",
    title: "/images/casio_trader.png",
    content: "Casio trader",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Smart trading with Casio.",
    genres: ["Finance", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 103,
    name: "Whitehat Jr.",
    videoId: null, // No Vimeo ID provided in the sheet
    url: "",
    thumbnail: "/category/commercials/101.jpeg",
    src: "/category/commercials/103.jpeg",
    title: "/images/whitehat_jr.png",
    content: "Whitehat Jr.",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Coding for kids with Whitehat Jr.",
    genres: ["Education", "Kids"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 104,
    name: "CNBC Hello Dreamers",
    videoId: null, // No Vimeo ID provided in the sheet
    url: "",
    thumbnail: "/category/commercials/102_.jpeg",
    src: "/category/commercials/101.jpeg",
    title: "/images/cnbc_hello_dreamers.png",
    content: "CNBC Hello Dreamers",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Inspiring dreams with CNBC.",
    genres: ["Inspirational", "Business"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 105,
    name: "Magic Bricks Tree Info",
    videoId: null, // No Vimeo ID provided in the sheet
    url: "",
    thumbnail: "/category/commercials/103_.jpeg",
    src: "/category/commercials/102.jpeg",
    title: "/images/magic_bricks_tree_info.png",
    content: "Magic Bricks Tree Info",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Learn about trees with Magic Bricks.",
    genres: ["Education", "Environment"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 106,
    name: "Indian Railways",
    videoId: 690472301,
    url: "https://vimeo.com/690472301",
    thumbnail: "/category/commercials/107.jpeg",
    src: "/category/commercials/103.jpeg",
    title: "/images/indian_railways.png",
    content: "Indian Railways",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Journey through India with Indian Railways.",
    genres: ["Travel", "Documentary"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 107,
    name: "TREsemme Red Carpet",
    videoId: 281260902,
    url: "https://vimeo.com/281260902",
    thumbnail: "/category/commercials/108.jpeg",
    src: "/category/commercials/107.jpeg",
    title: "/images/tresemme_red_carpet.png",
    content: "TREsemme Red Carpet",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Glamorous looks with TREsemme.",
    genres: ["Beauty", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 108,
    name: "Baby Shop",
    videoId: 275634004,
    url: "https://vimeo.com/275634004",
    thumbnail: "/category/commercials/109.jpeg",
    src: "/category/commercials/108.jpeg",
    title: "/images/baby_shop.png",
    content: "Baby Shop",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Everything for your little ones.",
    genres: ["Family", "Kids"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 109,
    name: "Baby Shop Ramadan",
    videoId: 275634004,
    url: "https://vimeo.com/275634004",
    thumbnail: "/category/commercials/110.jpeg",
    src: "/category/commercials/109.jpeg",
    title: "/images/baby_shop_ramadan.png",
    content: "Baby Shop Ramadan",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Celebrate Ramadan with Baby Shop.",
    genres: ["Family", "Festive"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 110,
    name: "Lloyd App",
    videoId: 275609320,
    url: "https://vimeo.com/275609320",
    thumbnail: "/category/commercials/111.jpeg",
    src: "/category/commercials/110.jpeg",
    title: "/images/lloyd_app.png",
    content: "Lloyd App",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Smart living with Lloyd App.",
    genres: ["Technology", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 111,
    name: "Samsung mobile",
    videoId: 275604345,
    url: "https://vimeo.com/275604345",
    thumbnail: "/category/commercials/112.jpeg",
    src: "/category/commercials/111.jpeg",
    title: "/images/samsung_mobile.png",
    content: "Samsung mobile",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Experience the future with Samsung mobile.",
    genres: ["Technology", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 112,
    name: "Samsung Silver fresh",
    videoId: 275603802,
    url: "https://vimeo.com/275603802",
    thumbnail: "/category/commercials/113.jpeg",
    src: "/category/commercials/112.jpeg",
    title: "/images/samsung_silver_fresh.png",
    content: "Samsung Silver fresh",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Fresh and stylish with Samsung.",
    genres: ["Technology", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 113,
    name: "Rupa Frontline",
    videoId: 275605621,
    url: "https://vimeo.com/275605621",
    thumbnail: "/category/commercials/114.jpeg",
    src: "/category/commercials/113.jpeg",
    title: "/images/rupa_frontline.png",
    content: "Rupa Frontline",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Stay ahead with Rupa Frontline.",
    genres: ["Fashion", "Lifestyle"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 114,
    name: "Magic Bus NGO Its My time",
    videoId: 127153484,
    url: "https://vimeo.com/127153484",
    thumbnail: "/category/commercials/115.jpeg",
    src: "/category/commercials/114.jpeg",
    title: "/images/magic_bus_ngo_its_my_time.png",
    content: "Magic Bus NGO Its My time",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Empowering youth with Magic Bus NGO.",
    genres: ["Social", "Inspirational"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 115,
    name: "Nido",
    videoId: 275594863,
    url: "https://vimeo.com/275594863",
    thumbnail: "/category/commercials/116.jpeg",
    src: "/category/commercials/115.jpeg",
    title: "/images/nido.png",
    content: "Nido",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Nutrition for growing kids.",
    genres: ["Health", "Family"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 116,
    name: "The Skoda Prize Film",
    videoId: 275382060,
    url: "https://vimeo.com/275382060",
    thumbnail: "/category/commercials/117.jpeg",
    src: "/category/commercials/116.jpeg",
    title: "/images/the_skoda_prize_film.png",
    content: "The Skoda Prize Film",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Celebrating excellence with Skoda.",
    genres: ["Automotive", "Documentary"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 117,
    name: "Himalaya Neem",
    videoId: 127156062,
    url: "https://vimeo.com/127156062",
    thumbnail: "/category/commercials/118.jpeg",
    src: "/category/commercials/117.jpeg",
    title: "/images/himalaya_neem.png",
    content: "Himalaya Neem",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Natural care with Himalaya Neem.",
    genres: ["Health", "Beauty"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 118,
    name: "Javed Akhtar AV",
    videoId: 295569791,
    url: "https://vimeo.com/295569791",
    thumbnail: "/category/commercials/119.jpeg",
    src: "/category/commercials/118.jpeg",
    title: "/images/javed_akhtar_av.png",
    content: "Javed Akhtar AV",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A tribute to Javed Akhtar.",
    genres: ["Biography", "Documentary"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
  {
    id: 119,
    name: "Max Healthcare",
    videoId: 275612895,
    url: "https://vimeo.com/275612895",
    thumbnail: "/category/commercials/119.png",
    src: "/category/commercials/119.jpeg",
    title: "/images/max_healthcare.png",
    content: "Max Healthcare",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Caring for your health with Max Healthcare.",
    genres: ["Health", "Documentary"],
    starring: ["Actor SS", "Actor TT"],
    director: "Director Name",
  },
];

export const alldocumentartiesinnerpage = [
  {
    id: 1,
    name: "Bittersweet (Short film) Trailer",
    videoId: 12345,
    url: "https://vimeo.com/12345",
    thumbnail: "/category/documentaries/2.jpeg",
    src: "/category/documentaries/2.jpeg",
    title: "/images/1.jpeg",
    content: "Bittersweet (Short film) Trailer",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A compelling short film/documentary.",
    genres: ["Drama", "Documentary"],
    starring: ["Actor XX", "Actor YY"],
    director: "Director Name",
  },
  {
    id: 2,
    name: "Retrospective Film on Balkrishna Doshi",
    videoId: 281262645,
    url: "https://vimeo.com/281262645",
    thumbnail: "/category/documentaries/2.jpeg",
    src: "/category/documentaries/2.jpeg",
    title: "/images/2.jpeg",
    content: "Retrospective Film on Balkrishna Doshi",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "A compelling short film/documentary.",
    genres: ["Drama", "Documentary"],
    starring: ["Actor XX", "Actor YY"],
    director: "Director Name",
  },
  {
    id: 3,
    name: "Right Forward (Docu) Trailer",
    videoId: 12345,
    url: "https://vimeo.com/12345",
    thumbnail: "/category/documentaries/2.jpeg",
    src: "/category/documentaries/2.jpeg",
    title: "/images/3.jpeg",
    content: "Right Forward (Docu) Trailer",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Right Forward is an inspiring documentary about young girls from Mumbai’s underserved communities who defy the odds through soccer. With support from NGO Magic Bus, they rise above adversity to represent India internationally, travelling to the U.S. to showcase their talent, forge connections, and prove that dreams have no boundaries.",
    genres: ["Drama", "Documentary"],
    starring: ["Actor XX", "Actor YY"],
    director: "Ruchi Narain",
  },
];

export const alllongformatinnerpage = [
  {
    id: 1,
    name: "Guilty (2020)",
    videoId: 693910565,
    url: "https://vimeo.com/693910565",
    thumbnail: "/category/longformat/1.jpeg",
    src: "/category/longformat/1.jpeg",
    title: "/images/1.jpeg",
    content: "Guilty (2020)",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "When a popular college heartthrob (Gurfateh Pirzada) is accused of rape by an introverted student, his girlfriend (Kiara Advani) embarks on a journey to uncover the truth, sifting through conflicting accounts and confronting her own beliefs in the process.",
    genres: ["Action", "Drama"],
    starring: ["Kiara Advani", "Taher Shabbir", "Gurfateh Pirzada", "Akanksha Ranjan Kapoor"],
    director: "Ruchi Narain",
  },
  {
    id: 2,
    name: "Hanuman Da Damdaar (2017)",
    videoId: 275610776,
    url: "https://vimeo.com/275610776",
    thumbnail: "/category/longformat/2.jpeg",
    src: "/category/longformat/2.jpeg",
    title: "/images/2.jpeg",
    content: "Hanuman Da Damdaar (2017)",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "Witness young Maruti transform from a meek child into the mighty Hanuman Da' Damdaar, learning courage and self-belief along the way. With its unique blend of vibrant animation, heartfelt storytelling, and laugh-out-loud humour, Hanuman Da’ Damdaar takes audiences on an unforgettable adventure filled with action, emotion, and the timeless journey of re-discovering a much-loved character.",
    genres: ["Action", "Drama"],
    starring: ["Salman Khan", "Saurabh Shukla", "Raveena Tandon", "Vinay Pathak", "Kunal Khemu", "Javed Akhtar"],
    director: "Ruchi Narain",
  },
  {
    id: 3,
    name: "Hanuman Da Damdaar - Chalisa",
    videoId: 12345,
    url: "https://vimeo.com/12345",
    thumbnail: "/category/longformat/3.jpeg",
    src: "/category/longformat/3.jpeg",
    title: "/images/3.jpeg",
    content: "Hanuman Da Damdaar - Chalisa",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "An exciting movie trailer.",
    genres: ["Action", "Drama"],
    starring: ["Actor AA", "Actor BB"],
    director: "Director Name",
  },
  {
    id: 4,
    name: "Hundred",
    videoId: 521252910,
    url: "https://vimeo.com/521252910",
    thumbnail: "/category/longformat/1.jpeg",
    src: "/category/longformat/1.jpeg",
    title: "/images/4.jpeg",
    content: "Hundred",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "An exciting movie trailer.",
    genres: ["Action", "Drama"],
    starring: ["Actor AA", "Actor BB"],
    director: "Director Name",
  },
  {
    id: 5,
    name: "Karmma Calling",
    videoId: 12345,
    url: "https://vimeo.com/12345",
    thumbnail: "/category/longformat/3.jpeg",
    src: "/category/longformat/3.jpeg",
    title: "/images/5.jpeg",
    content: "Karmma Calling",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "In a gripping exploration of revenge and redemption, we follow the story of Karma Talwar, an emotionally troubled young woman who embarks on a relentless quest to avenge her father's unjust downfall. Scarred by her family's shattered legacy, Karma is determined to expose the corruption and betrayal that led to her father's suffering. This nail-biting, binge-worthy tale of justice and vengeance will keep audiences hooked till the very end.",
    genres: ["Action", "Drama"],
    starring: ["Raveena Tandon", "Varun Sood", "Namrata Seth"],
    director: "Ruchi Narain",
  },
  {
    id: 6,
    name: "Salman Dubbing BTS",
    videoId: 12345,
    url: "https://vimeo.com/12345",
    thumbnail: "/category/longformat/2.jpeg",
    src: "/category/longformat/2.jpeg",
    title: "/images/6.jpeg",
    content: "Salman Dubbing BTS",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "An exciting movie trailer.",
    genres: ["Action", "Drama"],
    starring: ["Actor AA", "Actor BB"],
    director: "Director Name",
  },
  {
    id: 7,
    name: "The Divide BTS",
    videoId: 12345,
    url: "https://vimeo.com/12345",
    thumbnail: "/category/longformat/1.jpeg",
    src: "/category/longformat/1.jpeg",
    title: "/images/7.jpeg",
    content: "The Divide BTS",
    year: "2023",
    season: "1 Season",
    language: "Hindi",
    rating: "U/A 13+",
    description: "An exciting movie trailer.",
    genres: ["Action", "Drama"],
    starring: ["Actor AA", "Actor BB"],
    director: "Director Name",
  },
];
